import styled from 'styled-components';

import { Text, Dropdown, Button } from '@gympass/yoga';

export const Container = styled.div`
  display: flex;
  max-width: 600px;
  flex-direction: column;
  justify-items: start;
  gap: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  padding-left: ${({ theme }) => theme.yoga.spacing.medium}px;
  padding-right: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const Title = styled(Text.H5)`
  width: 100%;
  text-align: center;
`;

export const TherapyCompanionSelect = styled(Dropdown).attrs({
  full: true,
})`
  ul {
    max-height: 85px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
`;

export const CancelButton = styled(Button.Link)`
  color: ${({ theme }) => theme.yoga.colors.primary};
`;
